// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as CardFields$OrcaPaymentPage from "../Components/CardFields.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as CardCollectorBridge$OrcaPaymentPage from "./CardCollectorBridge.bs.js";

function RawCardCollector(props) {
  let __isBancontact = props.isBancontact;
  let cvcProps = props.cvcProps;
  let expiryProps = props.expiryProps;
  let cardProps = props.cardProps;
  let __isBancontact_value = __isBancontact !== undefined ? __isBancontact : false;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let themeObj = match.themeObj;
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let parentURL = match$1.parentURL;
  let setComplete = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.fieldsComplete);
  let setCvcError = cvcProps.setCvcError;
  let cvcNumber = cvcProps.cvcNumber;
  let isCVCValid = cvcProps.isCVCValid;
  let setExpiryError = expiryProps.setExpiryError;
  let cardExpiry = expiryProps.cardExpiry;
  let isExpiryValid = expiryProps.isExpiryValid;
  let updateCardEligibilityError = cardProps.updateCardEligibilityError;
  let cardBrand = cardProps.cardBrand;
  let setCardError = cardProps.setCardError;
  let cardNumber = cardProps.cardNumber;
  let updateCardSupport = cardProps.updateCardSupport;
  let isCardSupported = cardProps.isCardSupported;
  let isCardValid = cardProps.isCardValid;
  let isCardDetailsValid = Core__Option.getOr(isCVCValid, false) && Core__Option.getOr(isCardValid, false) && Core__Option.getOr(isCardSupported, false) && Core__Option.getOr(isExpiryValid, false);
  let empty = cardNumber === "" || cardExpiry === "" || cvcNumber === "";
  CardCollectorBridge$OrcaPaymentPage.useEmitCardState(cardNumber, cardExpiry, cvcNumber, cardBrand, isCardDetailsValid, empty, isCardValid, isExpiryValid, isCVCValid, true, undefined, undefined, undefined, undefined);
  React.useEffect(() => {
    setComplete(param => isCardDetailsValid);
  }, [isCardDetailsValid]);
  React.useEffect(() => {
    let handleEligibilityMessage = ev => {
      let dict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
      if (ev.source !== window.parent || ev.origin !== parentURL) {
        return;
      }
      if (Core__Option.isSome(dict["cardEligibilityStateUpdate"])) {
        let eligibilityState = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "cardEligibilityStateUpdate"));
        updateCardEligibilityError(Utils$OrcaPaymentPage.getBool(eligibilityState, "hasError", false) ? Utils$OrcaPaymentPage.getString(eligibilityState, "error", "") : undefined);
      }
      if (!Core__Option.isSome(dict["cardSupportStateUpdate"])) {
        return;
      }
      let supportState = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "cardSupportStateUpdate"));
      updateCardSupport(Utils$OrcaPaymentPage.getBool(supportState, "hasStatus", false) ? Utils$OrcaPaymentPage.getBool(supportState, "supported", true) : undefined);
    };
    window.addEventListener("message", handleEligibilityMessage);
    return () => {
      window.removeEventListener("message", handleEligibilityMessage);
    };
  }, [
    updateCardEligibilityError,
    updateCardSupport,
    parentURL
  ]);
  let reportCardFieldErrors = () => CardCollectorBridge$OrcaPaymentPage.reportValidationErrors(cardNumber, cardExpiry, cvcNumber, cardBrand, isCardSupported, isCardDetailsValid, setCardError, setExpiryError, setCvcError, localeString);
  let submitCallback = React.useCallback(ev => {
    let json = Utils$OrcaPaymentPage.safeParse(ev.data);
    let confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
    let isOuterValid = Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getDictFromJson(json), "isOuterValid", true);
    if (!confirm.doSubmit) {
      return;
    }
    if (!((__isBancontact_value || isCardDetailsValid) && isOuterValid)) {
      if (!__isBancontact_value) {
        return reportCardFieldErrors();
      } else {
        return;
      }
    }
    let match = CardUtils$OrcaPaymentPage.getExpiryDates(cardExpiry);
    let rawCardData = Object.fromEntries([
      [
        "cardNumber",
        cardNumber
      ],
      [
        "month",
        match[0]
      ],
      [
        "year",
        match[1]
      ],
      [
        "cvcNumber",
        cvcNumber
      ],
      [
        "cardBrand",
        cardBrand
      ]
    ]);
    Utils$OrcaPaymentPage.messageParentWindow(parentURL, [
      [
        "rawCardEvent",
        true
      ],
      [
        "rawCardData",
        rawCardData
      ]
    ]);
  }, [
    cardNumber,
    cardExpiry,
    cvcNumber,
    cardBrand,
    isCardDetailsValid,
    __isBancontact_value,
    localeString
  ]);
  Utils$OrcaPaymentPage.useSubmitPaymentDataFromParent(parentURL, submitCallback);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(CardFields$OrcaPaymentPage.make, {
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps,
          isBancontact: __isBancontact_value
        }),
        className: "flex flex-col w-full",
        style: {
          gridGap: themeObj.spacingGridColumn
        }
      }),
      className: "flex flex-col",
      style: {
        gridGap: themeObj.spacingGridColumn
      }
    })
  });
}

let make = RawCardCollector;

export {
  make,
}
/* jotai Not a pure module */
